import React from 'react';
import '../Styling/templateBuilder.css';
import axios from 'axios';
import OptionSelector from "./OptionSelector"
import TemplateViewer from "./TemplateViewer"
import TableColumns from "./TableColumns"
import autoBind from 'react-autobind';
import Templates from './Templates';
import {Grid, Row, Col} from 'react-bootstrap'
import URLGenerator from './URLGenerator';

class TemplateBuilder extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			tables: [],
			chosenTable: {
				tableName: "",
				tableID: ""
			},
			name: "",
			intent: "Retrieve",
			format: "CSV",
			commit: "True",
			script: "False",
			token: this.props.token,
			cachedValues: false,
			columns: {},
			dataTypes: {},
			units: [],
			scriptSelections: {},
			allOperations: {},
			tableOperations: [],
			timeZones: []
		};
		autoBind(this);
	}

	componentWillReceiveProps(nextProps){
		this.setState({
			token: nextProps.token
		});
	}

	componentDidMount(){
		if (!this.state.cachedValues && this.props.token && this.state.token !== ""){
			this.tokenAcquired();
		}
	}

	tokenAcquired(){
		try{
			this.requestTables();
			this.requestDataTypes();
			this.requestUnits();
			this.requestTimeZones();
			this.setState({
				cachedValues: true
			});
		}
		catch (e) {
			if (e){
				console.error(e)
			}
		}

	}

	requestTables() {
		return new Promise(((resolve, reject) => {
			var url = URLGenerator.GetURL('execute','?');
			return axios.post(url, Templates.formRequest(),
				{
					headers: { 'Content-Type': 'text/plain'}
				}).then(function (response) {
				return resolve(response.data.RetrieveTables.TableEntry);
			}).catch(function (error) {
				return reject(error);
			})
		})).then(function (response) {
			let tableData = [];
			let operationsData = {};
			for (let i = 0; i < response.length; i++){
				let table = {
					tableName: response[i].Name,
					tableID: response[i].Id
				};
				operationsData[response[i].Name] = response[i].SupportedOperations;
				tableData.push(table);
			}
			this.setState({
				tables: tableData,
				allOperations: operationsData
			});
		}.bind(this));
	}

	updateTable(table){
		let jsonTable = JSON.parse(table);
		this.setState({
			chosenTable: jsonTable
		});
		this.setState({
			tableOperations: this.state.allOperations[jsonTable.tableName]
		});
		this.requestColumns(jsonTable.tableID)
	}

	requestColumns(id){
		return new Promise(((resolve, reject) => {
			var url = URLGenerator.GetURL('execute','?');
			return axios.post(url, Templates.getPostBody("", Templates.getColumnTemplate(id)),
				{
					headers: { 'Content-Type': 'text/plain'}
				}).then(function (response) {
				return resolve(response.data.RetrieveColumns.TableEntry);
			}).catch(function (error) {
				return reject(error);
			})
		})).then(function (response) {
			let data = {};
			for (let i = 0; i < response.length; i++) {
				data[response[i].Name] = response[i];
				data[response[i].Name].Checked = false;
				if (this.state.dataTypes[response[i].DataTypeId].IsMeasurement === "True"){
					data[response[i].Name].selectedUnit = "";
					data[response[i].Name].displayMeasurement = true;
				}
				else {
					data[response[i].Name].displayMeasurement = false;
				}
				if (this.state.dataTypes[response[i].DataTypeId].Name === "Timestamp"){
					data[response[i].Name].timeData = {
						selectedTimeZone: "",
						selectedTimeFormat: ""
					};
					data[response[i].Name].displayTimeData = true
				}
				else {
					data[response[i].Name].displayTimeData = false;
				}

			}
			this.setState({
				columns: data
			})
		}.bind(this));
	}

	requestDataTypes(){
		return new Promise(((resolve, reject) => {
			var url = URLGenerator.GetURL('execute','?');
			return axios.post(url, Templates.getPostBody("", Templates.getDataTypeTemplate()),
				{
					headers: { 'Content-Type': 'text/plain'}
				}).then(function (response) {
				return resolve(response.data.RetrieveDataTypes.TableEntry);
			}).catch(function (error) {
				return reject(error);
			})
		})).then(function (response) {
			let data = {};
			for (let i = 0; i < response.length; i++) {
				data[response[i].Id] = response[i];
			}
			this.setState({
				dataTypes: data
			})
		}.bind(this));
	}

	requestUnits(){
		return new Promise(((resolve, reject) => {
			var url = URLGenerator.GetURL('execute','?');
			return axios.post(url, Templates.getPostBody("", Templates.getUnitTemplate()),
				{
					headers: { 'Content-Type': 'text/plain'}
				}).then(function (response) {
				return resolve(response.data.RetrieveMeasurementUnits.TableEntry);
			}).catch(function (error) {
				return reject(error);
			})
		})).then(function (response) {
			let data = [];
			for (let i = 0; i < response.length; i++) {
				data.push(response[i])
			}
			this.setState({
				units: data
			})
		}.bind(this));
	}

	requestTimeZones(){
		return new Promise(((resolve, reject) => {
			var url = URLGenerator.GetURL('execute','?');
			return axios.post(url, Templates.getPostBody("", Templates.getTimeZonesTemplate()),
				{
					headers: { 'Content-Type': 'text/plain'}
				}).then(function (response) {
				return resolve(response.data[""].TableEntry);
			}).catch(function (error) {
				return reject(error);
			})
		})).then(function (response) {
			let data = [];
			for (let i = 0; i < response.length; i++){
				let display = this.formatTimeZoneDisplay(response[i]);
				let tempTZData = response[i];
				tempTZData.Display = display;
				data.push(tempTZData);
			}
			this.setState({
				timeZones: data
			})
		}.bind(this));
	}

	formatTimeZoneDisplay(timeZoneData){
		let display = "(UTC";
		timeZoneData.UtcOffset.charAt(0) === '-' ? display += timeZoneData.UtcOffset.substring(0, timeZoneData.UtcOffset.length-3): display+= ("+" + timeZoneData.UtcOffset.substring(0, timeZoneData.UtcOffset.length-3));
		display += ") " + timeZoneData.Abbreviation + " - " + timeZoneData.Name;
		return display;
	}

	updateName(name){
		this.setState({
			name: name
		});
	}
	updateIntent(intent){
		this.setState({
			intent: intent
		});
	}
	updateFormat(format){
		this.setState({
			format: format
		});
	}
	updateCommit(commit){
		this.setState({
			commit: commit
		});
	}
	updateScript(script){
		this.setState({
			script: script
		});
	}
	updateScriptOptions(script, value){
		let dict = this.state.scriptSelections;
		dict[script] = value;
		this.setState(
			{
				scriptSelections: dict
			}
		)
	}
	updateColumnVisibility(name, checked){
		let col = this.state.columns;
		col[name].Checked = checked;
		this.setState({
			columns: col
		})
	}
	updateColumnUnit(name, unit){
		let col = this.state.columns;
		col[name].selectedUnit = unit;
		this.setState({
			columns: col
		})
	}

	updateTimeData(name, timeFormat, timeZone){
		let col = this.state.columns;
		col[name].timeData = {
			selectedTimeZone: timeZone,
			selectedTimeFormat: timeFormat
		};
		this.setState({
			columns: col
		})
	}

    render(){
        return(
            <Grid style={{width: 'auto', height: '100%'}}>
	            <Row id="left-column">
		            <Col md={6} style={{display:'flex', flexDirection:'column', width:'50%'}}>
						<OptionSelector
							tables = {this.state.tables}
							operations = {this.state.tableOperations}
							chosenTable = {this.state.chosenTable.tableName}
							onTableChange = {(table) => this.updateTable(table)}
							onNameChange = {(name) => this.updateName(name)}
							onIntentChange = {(intent) => this.updateIntent(intent)}
							onFormatChange = {(format) => this.updateFormat(format)}
							onCommitChange = {(commit) => this.updateCommit(commit)}
							onScriptChange = {(script) => this.updateScript(script)}
							onScriptSelectionChange = {(script, value) => this.updateScriptOptions(script, value)}
						/>
						<TableColumns
							columns = {this.state.columns}
							dataTypes = {this.state.dataTypes}
							units = {this.state.units}
							timeZones = {this.state.timeZones}
							onCheck = {(name, checked) => this.updateColumnVisibility(name, checked)}
							onChoice = {(name, unit) => this.updateColumnUnit(name, unit)}
							onTimeSelect = {(name, timeFormat, timeZone) => this.updateTimeData(name, timeFormat, timeZone)}
						/>
		            </Col>
		            <Col md={6} style={{display:'flex', flexDirection:'column', width:'50%'}}>
			            <TemplateViewer values={this.state}/>
		            </Col>
	            </Row>
            </Grid>
        );
    }
}

export default TemplateBuilder;
